import { createSlice } from '@reduxjs/toolkit';
import { LiveStreamState } from 'models/liveStream/types';
import { liveStreamActions } from 'models/liveStream/actions';

export const LIVESTREAM_STORE_NAME = 'liveStream';

const liveStreamSlice = createSlice({
  name: LIVESTREAM_STORE_NAME,
  initialState: {
    currentChannel: null,
    boothLiveStreamingLastTimeStamp: {},
    boothLiveStreamingStatus: {},
  } as LiveStreamState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(liveStreamActions.joinChannel, (state, action) => {
      state.currentChannel = action.payload?.channel;
    });
    builder.addCase(liveStreamActions.updateIsClosable, (state, action) => {
      state.isClosable = action.payload;
    });
    builder.addCase(liveStreamActions.updateBoothLiveStreamingLastTimeStamp, (state, action) => {
      if (action.payload.streamingLastTimeStamp != null) {
        state.boothLiveStreamingLastTimeStamp[action.payload.boothId] = action.payload.streamingLastTimeStamp;
      } else {
        delete state.boothLiveStreamingLastTimeStamp[action.payload.boothId];
      }
    });
    builder.addCase(liveStreamActions.updateBoothLiveStreamingStatus, (state, action) => {
      if (action.payload.streamingStatus) {
        state.boothLiveStreamingStatus[action.payload.boothId] = action.payload.streamingStatus;
      } else {
        delete state.boothLiveStreamingStatus[action.payload.boothId];
      }
    });
    builder.addCase(liveStreamActions.cleanUpBoothLiveStreamingStatus, (state, action) => {
      const excludeBoothIds = new Set(action.payload.excludeBoothIds);

      Object.keys(state.boothLiveStreamingStatus).filter((it) => !excludeBoothIds.has(it))
        .forEach((cleaningUpBoothId) => delete state.boothLiveStreamingStatus[cleaningUpBoothId]);

      Object.keys(state.boothLiveStreamingLastTimeStamp).filter((it) => !excludeBoothIds.has(it))
        .forEach((cleaningUpBoothId) => delete state.boothLiveStreamingLastTimeStamp[cleaningUpBoothId]);
    });
  },
});

const liveStreamReducer = liveStreamSlice.reducer;
export default liveStreamReducer;
